import {
    Component,
    OnInit,
    AfterViewInit,
    ElementRef,
    ViewChild,
    Input,
    Output,
    EventEmitter,
    SimpleChange
} from '@angular/core';

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare const $: any;

@Component({
  standalone: false,
    selector: 'caaks-datatable',
    templateUrl: 'datatable.component.html',
    styleUrls: ['./datatable.component.scss']
})

export class DataTableComponent implements OnInit, AfterViewInit {
    public dataTable: DataTable = {} as DataTable;
    public table : any;
    @ViewChild('datatables') datatableElement: ElementRef = {} as ElementRef;
    @Input() elementId: string = 'datatable';
    @Input() options: any = {};
    @Input() dataSource : any[] = [];
    @Input() headerCols : any[] = [];
    @Input() paging : boolean = false;
    @Input() ajax : boolean = false;
    // @Input() onSelect : Function = () => {};
    @Input() deselectItem : Function = () => {};
    @Input() rowActions: any[] = [];
    @Output() order = new EventEmitter<any>();
    @Output() selectItem = new EventEmitter<Array<string>>();
    @Output() ajaxProcessing = new EventEmitter<any>();

    _options: any = {
      "paging": this.paging,
      "searching": false,
      "select": true,
      "pagingType": "full_numbers",
      "lengthMenu": [
        [10, 25, 50, -1],
        [10, 25, 50, "All"]
      ],
      responsive: true,
      language: {
        url: '/assets/localisation/datatables-fr_FR.json',
        search: "_INPUT_",
        searchPlaceholder: "Rechercher",
      },     
    };

    ngOnInit(): void {
        this.dataTable = {
            headerRow: this.headerCols,
            footerRow: this.headerCols,
            dataRows: this.dataSource
        };
        this._options = Object.assign(this._options, this.options)
        
    }

    ngAfterViewInit() {
      const vm = this
      $(document).ready( function () {
        if(vm.ajax){
          vm._options.ajax = function(data:any, callback:Function, settings:any){
            vm.ajaxProcessing.emit({data, callback, settings})
          }
        }
        vm.table = $('#'+vm.elementId).DataTable(vm._options);
        vm.table
          .on('order.dt', function (e:object, settings:any, ordArr:Array<string>) {
              vm.order.emit({e: e, keys: settings.aaSorting})
          })
          .on( 'select', function(e:object, dt:any, type:string, indexes:Array<string>){
            const rowData = vm.table.rows( indexes ).data().toArray();
            vm.selectItem.emit(rowData)
          });

        if(vm.deselectItem){
          vm.table
          .on( 'deselect', vm.deselectItem );
        }
      });
    }

    ngOnChanges(changes: SimpleChange){
        this.dataTable = {
            headerRow: this.headerCols,
            footerRow: this.headerCols,
            dataRows: this.dataSource
        };
    }
}
